import React from 'react';
import Icon from '../../../components/AppIcon';

const ImportOptionsPanel = ({ options, onOptionsChange }) => {
  const handleOptionChange = (key, value) => {
    onOptionsChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">Import Options</h3>
      {/* Dynamic Links */}
      <div className="flex items-start space-x-3">
        <input
          type="checkbox"
          id="enableDynamicLinks"
          checked={options?.enableDynamicLinks}
          onChange={(e) => handleOptionChange('enableDynamicLinks', e?.target?.checked)}
          className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <div className="flex-1">
          <label htmlFor="enableDynamicLinks" className="text-sm font-medium text-gray-900 cursor-pointer">
            Enable Dynamic Short Links
          </label>
          <p className="text-xs text-gray-500 mt-1">
            Automatically create trackable short URLs for imported QR codes with analytics
          </p>
        </div>
      </div>
      {/* Auto Detect Type */}
      <div className="flex items-start space-x-3">
        <input
          type="checkbox"
          id="autoDetectType"
          checked={options?.autoDetectType}
          onChange={(e) => handleOptionChange('autoDetectType', e?.target?.checked)}
          className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <div className="flex-1">
          <label htmlFor="autoDetectType" className="text-sm font-medium text-gray-900 cursor-pointer">
            Auto-detect QR Type
          </label>
          <p className="text-xs text-gray-500 mt-1">
            Automatically identify QR code types (URL, Email, Phone, etc.) based on content
          </p>
        </div>
      </div>
      {/* Duplicate Handling */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-900">
          Duplicate Handling
        </label>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="create_new"
              name="duplicateHandling"
              value="create_new"
              checked={options?.duplicateHandling === 'create_new'}
              onChange={(e) => handleOptionChange('duplicateHandling', e?.target?.value)}
              className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="create_new" className="text-sm text-gray-700 cursor-pointer">
              Create new (ignore duplicates)
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="skip"
              name="duplicateHandling"
              value="skip"
              checked={options?.duplicateHandling === 'skip'}
              onChange={(e) => handleOptionChange('duplicateHandling', e?.target?.value)}
              className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="skip" className="text-sm text-gray-700 cursor-pointer">
              Skip duplicates
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="update"
              name="duplicateHandling"
              value="update"
              checked={options?.duplicateHandling === 'update'}
              onChange={(e) => handleOptionChange('duplicateHandling', e?.target?.value)}
              className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="update" className="text-sm text-gray-700 cursor-pointer">
              Update existing (overwrite)
            </label>
          </div>
        </div>
        <p className="text-xs text-gray-500">
          How to handle QR codes with content that already exists in your library
        </p>
      </div>
      {/* Privacy Mode */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-900">
          Privacy Mode
        </label>
        <select
          value={options?.defaultPrivacy}
          onChange={(e) => handleOptionChange('defaultPrivacy', e?.target?.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="basic">Basic Analytics</option>
          <option value="extended">Extended Tracking</option>
          <option value="anonymous">Anonymous Only</option>
        </select>
        <p className="text-xs text-gray-500">
          Default analytics and tracking level for imported QR codes
        </p>
      </div>
      {/* Processing Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} className="text-blue-600 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-blue-800">Processing Features</h4>
            <ul className="text-xs text-blue-700 mt-1 space-y-1">
              <li>• Automatic QR code decoding from images and PDFs</li>
              <li>• Styling analysis and color extraction</li>
              <li>• Multiple QR detection per file</li>
              <li>• Campaign assignment and organization</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportOptionsPanel;